export default "__VITE_ASSET__C3mnfk5Z__"